// extracted by mini-css-extract-plugin
export var comments = "comments-module--comments--f8217";
export var container = "comments-module--container--f3440";
export var disabledContent = "comments-module--disabled-content--a1796";
export var form = "comments-module--form--d2463";
export var header = "comments-module--header--e2ad7";
export var loading = "comments-module--loading--a7fbc";
export var noComments = "comments-module--no-comments--d0bd1";
export var submitButton = "comments-module--submit-button--c95a2";
export var success = "comments-module--success--0728f";
export var successText = "comments-module--success-text--24fd9";
export var textarea = "comments-module--textarea--f755b";
export var title = "comments-module--title--fd63e";